import { css } from 'styled-components';
import { COLORS } from '~/src/styles/tokens/colors';
import { rem } from '~/src/helpers/rem-converter.helper';
import { BORDER_RADIUS } from '~/src/styles/tokens/border-radius';

export const ScrollbarStyles = css`
    scrollbar-width: thin;
    scrollbar-color: ${COLORS.controlsInactiveTabBar} transparent;

    ::-webkit-scrollbar {
        -webkit-appearance: none;
        width: ${rem(5)};

        &-thumb {
            border: ${rem(4)} solid ${COLORS.controlsInactiveTabBar};
            border-radius: ${BORDER_RADIUS.normal8};
        }
    }
`;
